import uploadrequest  from './uploadrequest'
import tcutils from './tcutils'

function Chunk (uploader, file, chunkNum,fileData) {
  tcutils.defineNonEnumerable(this, 'uploader', uploader)
  tcutils.defineNonEnumerable(this, 'file', file)
  tcutils.defineNonEnumerable(this, 'fileData', fileData)
  this.url = "";
  this.chunkNum = chunkNum
  this.retries = 0
  this.state = STATUS.PENDING
  this.uploadProgress = 0
  this.xhr = null;
}

var STATUS = Chunk.STATUS = {
  PENDING: 'pending',
  UPLOADING: 'uploading',
  READING: 'reading',
  SUCCESS: 'success',
  ERROR: 'error',
  COMPLETE: 'complete',
  PROGRESS: 'progress',
  RETRY: 'retry',
}

tcutils.extend(Chunk.prototype, {
  error: function (e) {
    console.log(`第${this.chunkNum}片上传出错`);
    this.state = STATUS.ERROR
    if(this.retries < this.uploader.opts.maxChunkRetries){
      this.retries++
      console.log(`第${this.chunkNum}片第${this.retries}次重试上传`);
      this.send(this.url,this.fileData);
    }else{
      console.log(`第${this.chunkNum}片重试上传失败`);
      this.file.error(this.chunkNum);
    }
  },
  success: function (e) {
    console.log('分片上传成功',e);
    this.completed();
  },
  abort: function () {
    let xhr = this.xhr
    this.xhr= null
    if (xhr) {
      xhr.abort()
    }
  },
  send : function(url,_chunkfile){
    this.state = STATUS.UPLOADING
    this.xhr = uploadrequest({
      url:url,
      onProgress:this.progress,
      onError:this.error,
      onSuccess:this.success,
      file:_chunkfile,
      filename:this.file.name,
      thischunk:this
    })
  },
  progress: function (e) {
    this.uploadProgress = parseInt(e.percent);
    this.file.updateProgress()
    console.log(this.uploadProgress);
  },
  completed: function(){
    this.uploadProgress = 100;
    this.state = STATUS.COMPLETE;
    console.log(`切片${this.chunkNum}上传完了`)
    this.file.oneChunkComplete(this.chunkNum)
  },
  sizeUploaded: function () {
    var size = this.fileData.size
    if (this.state !== STATUS.COMPLETE) {
      size = this.uploadProgress * size /100
    }
    return size
  },
})

export default  Chunk
